module.exports = __webpack_public_path__ + "static/media/nossa.13f09072.webp";